//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Lession from "@/components/Lession";
import { getCourseList } from "@/api/home";
import { staticHost } from "@/common/js/config";

import { mapGetters } from "vuex"
export default {
  components: {
    Lession
  },
  data() {
    return {
      staticHost,
      imgList: {
        moreLessin: require("@/common/image/homePage/lession.png"),
        change: require("@/common/image/homePage/change.png")
      },
      lessionList: []
    };
  },
  computed: {
    ...mapGetters(['college'])
  },
  props: {
    websiteCourseId: {
      default: 0,
      type: Number
    },
    collegeId: {
      default: 0,
      type: Number
    },
    numberval: {
      default: 0, // 精选栏目下最后一个动态课程  第一个图片筛选掉
      type: Number
    }
  },
  methods: {
    //  更多
    moreLession() {
      //this.$emit("moreLession");
      this.$router.push({
        path: "/LessionList",
        query: {
          collegeId: this.college.id,
          websiteCourseId: this.websiteCourseId         
        }
      });
    },
    //  换一批
    changeNew() {
      //this.$emit("changeNew");
      this.lessionList = this.lessionList.reverse();
    },
    initData() {
      let data = {
        currentPage: 1,
        pageSize: 10,
        collegeId: 0, // 子院校传相应id，平台0
        websiteCourseId: this.websiteCourseId
      };
      getCourseList(data).then(res => {
        if(res.success){
          this.lessionList = res.entity.courseList;
        }
      });
    },
    goDetail(val) {
      console.log(val);
      if (val.sellType === "LIVE") {
        let json = {
          courseid: val.courseId||val.id
        }
        if(val.topic_type == 1){
          json.topic_type = 1
        }
        this.$router.push({
          path: "/LessionDetail",
          query: json
        }); 
        //this.$router.push(`/watch/${val.courseId}`);
      } else {
        let json = {
          courseid: val.courseId
        }
        if(val.topic_type == 1){
          json.topic_type = 1
        }
        this.$router.push({
          path: "/LessionDetail",
          query: json
        });
        
      }
    }
  },
  mounted() {
    this.initData();
  }
};



// WEBPACK FOOTER //
// ./src/components/lessionChoose.vue